import React from 'react';
import { Card, CardContent } from './ui/card';
import { Rocket, Wrench, TestTube, Cable } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Rocket,
      title: "UAS Design and Development",
      description: "Concept development, requirements refinement, trade studies, system architecture, and design support for rapid prototyping."
    },
    {
      icon: Wrench,
      title: "Build, Integration, and Ground Test",
      description: "Avionics and payload integration support, electrical architecture, bring-up troubleshooting, and ground test readiness."
    },
    {
      icon: TestTube,
      title: "Flight Test Support",
      description: "Test planning, instrumentation strategy, flight readiness support, and post-flight data review."
    },
    {
      icon: Cable,
      title: "Short-Run Wiring and Cable Assemblies",
      description: "Prototype wiring harnesses, custom cables/breakouts, labeling and documentation, and continuity/functional checks."
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-4">
            Our Services
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Engineering support for unmanned aviation programs, tailored for rapid iteration and practical execution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-7xl mx-auto">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <Card 
                key={index}
                className="group relative overflow-hidden border-2 border-slate-200 hover:border-blue-400 transition-all duration-300 hover:shadow-2xl cursor-pointer"
              >
                {/* Blueprint Grid Background */}
                <div 
                  className="absolute inset-0 z-0 opacity-5 group-hover:opacity-10 transition-opacity duration-300"
                  style={{
                    backgroundColor: '#f8fafc',
                    backgroundImage: `
                      linear-gradient(rgba(59, 130, 246, 0.3) 1px, transparent 1px),
                      linear-gradient(90deg, rgba(59, 130, 246, 0.3) 1px, transparent 1px)
                    `,
                    backgroundSize: '30px 30px'
                  }}
                />

                <CardContent className="p-8 relative z-10">
                  <div className="mb-6 inline-flex p-4 bg-blue-100 rounded-xl group-hover:bg-blue-600 transition-colors duration-300">
                    <IconComponent className="w-8 h-8 text-blue-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  
                  <h3 className="text-2xl font-bold text-slate-800 mb-4 group-hover:text-blue-600 transition-colors duration-300">
                    {service.title}
                  </h3>
                  
                  <p className="text-slate-600 leading-relaxed text-lg">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;


